import { withAuth } from '../../auth/withAuth';
import AssignmentReview from '../../AssignmentReview/AssignmentReview';

const AssignmentQuestionReviewWithAuth = withAuth(AssignmentReview);

export default AssignmentQuestionReviewWithAuth;
